module.exports = __webpack_public_path__ + "static/media/Data_source.acf570ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/Data_source.png
// module id = 983
// module chunks = 0